<template>
  <layout name="LayoutDefault">
    <div class="Contact">

      <!-- Page Content -->
      <div class="container">
        <!-- Page Features -->
        <div class="contents">
          <div class="row ">

            <div class="map col-lg-6">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d228.32230960722868!2d90.41133827094464!3d23.706088492596006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755b971cec4c259%3A0x9969541e9840ad0!2sKatha+Prokash!5e0!3m2!1sen!2sbd!4v1548870508735" width="100%" height="515" frameborder="0" style="border:0" allowfullscreen></iframe>
            </div>

            <div class="contact-form col-lg-6">
              <div >
                <h2>যোগাযোগ</h2>
              </div>
              <h5 class="subtitle">যেকোনো সাহায্যর জন্য যোগাযোগ করতে নিচের ফরমটি পূরণ করে পাঠান </h5>
              <form id="contact" @submit="checkForm" action="#" method="post">
                <div v-if="errors.length" class="alert alert-warning">
                  <b>Please correct the following error(s):</b>
                <ul>
                  <li v-for="error in errors">{{ error }}</li>
                </ul>
                </div>

                <!-- <div class="alert alert-success" v-if="contactSuccess">আপনার বার্তাটি সফলভাবে পাঠানো হয়েছে ।</div> -->

                <div class="form-group">
                  <label for="exampleInputName">নাম<span class="required">*</span></label>
                  <input type="text" class="form-control" id="exampleInputName" name="name" v-model="name" placeholder=" আপনার নাম লিখুন" required>
                </div>

                <div class="form-group">
                  <label for="exampleInputEmail1">ইমেইল<span class="required">*</span></label>
                  <input type="email" class="form-control" id="exampleInputEmail1" name="email" v-model="email" aria-describedby="emailHelp" placeholder=" আপনার ইমেইল এখানে লিখুন" required>
                  <small id="emailHelp" class="form-text text-muted"> আমরা আপনার ইমেইল কারো সাথে শেয়ার করিব না</small>
                </div>

                <div class="form-group">
                  <label for="exampleInputPhone"> ফোন</label>
                  <input type="text" class="form-control" name="phone" id="exampleInputPhone" v-model="phone" placeholder=" আপনার ফোন নাম্বার এখানে দিন" required>
                </div>

                <div class="form-group">
                  <label for="exampleInputMessage">মন্তব্য<span class="required">*</span></label>
                  <textarea class="form-control" name="comments" id="exampleInputMessage" v-model="comments" rows="2" placeholder="আপনার মন্তব্য এখানে লিখুন" required></textarea>
                </div>

                <div class="form-group">
                  <label for="exampleInputPhone">চ্যালেঞ্জ কোড <span class="font-weight-bold">{{numFrist}}</span> + <span class="font-weight-bold">{{numSecond}}</span> ?</label>
                  <input type="number" class="form-control" autocomplete="off" name="challenge_code" id="challenge_code" v-model="challenge_code" placeholder="চ্যালেঞ্জ কোড এর উত্তর এখানে লিখুন" required>
                </div>

                <button type="submit" class="btn btn-primary">পাঠান</button>
              </form>

            </div>


          </div>

        </div>
      </div>
      <!-- /.container -->

    </div>
  </layout>
</template>

<script>
import Layout from '../layouts/Layout';

export default {
  name: `Home`,
  components: {
    Layout,
  },
    data () {
        return {
            errors: [],
            numFrist: Math.floor(Math.random() * 6 + 1),
            numSecond: Math.floor(Math.random() * 6 + 1),
            contactSuccess: false,
            name: null,
            email: null,
            phone: null,
            comments: null,
            challenge_code: null,
            sum: null,
            debug: false,
            id: 0,
            msg: 'Hey Nic Raboy'
        }
    },
    methods: {
        checkForm: function (e) {
            if (this.name && this.email && this.phone && this.comments && this.challenge_code) {
                e.preventDefault();
                this.sum = parseInt(this.numFrist) + parseInt(this.numSecond);
                if (this.challenge_code != this.sum) {
                    //console.log(this.sum);
                    //console.log(this.challenge_code);
                    this.errors.push('Challenge code not mathed.');
                    return false;
                }
                this.contactSuccess = true;
                let formData = {
                  name: this.name,
                  email: this.email,
                  phone: this.phone,
                  comments: this.comments,
                };

              this.$http
                .post("visitor-query/store", formData)
                .then(response => {
                  if (response.data.status) {
                    this.flashMessage.success({
                      message: "আপনার বার্তাটি সফলভাবে পাঠানো হয়েছে ।"
                    });
                    $('#contact')[0].reset();
                  } else {
                    this.flashMessage.error({
                      message: response.data.message
                    });
                  }
                })
                .catch(e => {
                  if (e.response) {
                    this.flashMessage.error({
                      message: e.response.data.message
                    });
                  }
                });
                return false;
            }

            this.errors = [];


            if (!this.name) {
                this.errors.push('Name required.');
            }
            if (!this.email) {
                this.errors.push('Email required.');
            }
            if (!this.phone) {
                this.errors.push('Phone required.');
            }
            if (!this.comments) {
                this.errors.push('Comments required.');
            }
            if (!this.challenge_code) {
                this.errors.push('Challenge required.');
            }

            e.preventDefault();
        }
    }
};
</script>
